import axios from "axios";
import { URL } from "./url";





const http = axios.create({
    baseURL: URL,
    timeout: 30 * 1000,
    withCredentials: true,
});

const downhttp = axios.create({
    baseURL: URL,
    timeout: 30 * 1000,
    withCredentials: true,
    responseType: "blob",    // 下载文件时, 必须设置responseType为blob, 这样axios会自动处理响应数据, 并返回一个Blob对象, 而不是字符串
});

const config_interceptor = (config) => {
    const csrf_token = localStorage.getItem('csrf_token');
    const access_token = localStorage.getItem('access_token');
    const refresh_token = localStorage.getItem('refresh_token');
    if (csrf_token) {
        config.headers["X-CSRFToken"] = csrf_token;
    }
    if (access_token) {
        config.headers["Authorization"] = `Bearer ${access_token}`;
    }
    if (refresh_token) {
        config.headers["token"] = refresh_token;
    }

    return config;
}

http.interceptors.request.use(
    config_interceptor,

    (error) => {
        return Promise.reject(error);
    },

);

downhttp.interceptors.request.use(
    config_interceptor,

    (error) => {
        return Promise.reject(error);
    },

);

export { http, downhttp };